import {
    ComponentsProps,
    ComponentsOverrides,
    ComponentsVariants,
    listItemClasses,
    listItemTextClasses,
    typographyClasses,
} from '@mui/material';
import { Theme } from '@mui/system/createTheme';
import { baseTheme } from '../base-theme';

export const MuiOrderedList: {
    defaultProps?: ComponentsProps['MuiOrderedList'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiOrderedList'];
    variants?: ComponentsVariants['MuiOrderedList'];
} = {
    defaultProps: {
        dense: true,
        component: 'ol',
    },
    styleOverrides: {
        root: {
            listStyle: 'numeric',
            paddingInlineStart: '1rem',
            'li::marker': {
                color: baseTheme.palette.text.primary,
            },
        },
    },
};

export const MuiOrderedListItem: {
    defaultProps?: ComponentsProps['MuiOrderedListItem'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiOrderedListItem'];
    variants?: ComponentsVariants['MuiOrderedListItem'];
} = {
    styleOverrides: {
        root: {
            display: 'list-item',
            [`&.${listItemClasses.dense}`]: {
                paddingInlineStart: baseTheme.spacing(baseTheme.tokens.spacing.xxs),
                paddingInlineEnd: baseTheme.spacing(baseTheme.tokens.spacing.xs),
            },
            [`& > .${listItemTextClasses.root} > .${typographyClasses.root}`]: baseTheme.typography.body1,
        },
    },
};
